var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { AVAILABLE_LANGUAGES, DEFAULT_LANGUAGE, } from "../LanguageSelector/constants";
import { getCleanLanguages, getNormalizedCurrentLanguage, getOrderedLanguages, } from "../LanguageSelector/utils";
import { Icon } from "../Icon";
import DrawerItem from "./DrawerItem";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-drawerLanguages",
    languages: ["en-GB", "it-IT"],
};
const DrawerLanguages = (_a) => {
    var { currentLanguage = DEFAULT_LANGUAGE, languages, onChangeLanguage, className } = _a, rest = __rest(_a, ["currentLanguage", "languages", "onChangeLanguage", "className"]);
    const classList = classNames("tecma-drawerLanguages", className);
    const cleanLanguages = getCleanLanguages(languages);
    const orderedLanguages = getOrderedLanguages(cleanLanguages, false);
    const normalizedCurrentLanguage = getNormalizedCurrentLanguage(currentLanguage, orderedLanguages);
    const handleOnChangeLanguage = (language) => {
        onChangeLanguage(language);
    };
    return (_jsx("div", Object.assign({ className: classList }, rest, { children: orderedLanguages.map((language) => {
            const isSelected = normalizedCurrentLanguage === language;
            return (_jsx(DrawerItem, { label: AVAILABLE_LANGUAGES[language].language, description: AVAILABLE_LANGUAGES[language].region, className: `${isSelected ? "selected" : ""}`, rightIcon: isSelected ? _jsx(Icon, { iconName: "check-circle", filled: true, size: "medium" }) : undefined, onClick: () => handleOnChangeLanguage(language) }));
        }) })));
};
DrawerLanguages.defaultProps = defaultProps;
export default React.memo(DrawerLanguages);
